import { api } from "@/lib/api";
export const ExamStructureAPI = {
  list: (params) => api.get("/exam-structure", { params }).then((r) => r.data),
  get: (id) => api.get(`/exam-structure/${id}`).then((r) => r.data),
  create: (body) => api.post("/exam-structure", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/exam-structure/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/exam-structure/${id}`).then((r) => r.data),
  nodeTypes: () => api.get("/exam-structure/node-types").then((r) => r.data),
};
